module.exports = "/_next/static/images/ed3ee3704371108f971b0adf4c82b701-girl-with-card-lg.png";